export const SettingsView: React.FunctionComponent = () => {
  return null;
};
